// src/pages/EditProduct.js
import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { doc, getDoc, updateDoc, deleteDoc } from "firebase/firestore";
import { db } from "../utils/firebaseconfig";
import "../styles/addProduct.css"; // ✅ you're already using this one

function EditProduct() {
  const { productId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [product, setProduct] = useState({
    title: "",
    description: "",
    category: "",
    price: "",
    condition: "new",
    brand: "",
    dimensions: "",
    weight: "",
    countryOfOrigin: "",
    keywords: "",
  });

  // ✅ Only one useEffect needed
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        if (location.state?.product) {
          const data = location.state.product;
          setProduct({
            ...data,
            keywords: Array.isArray(data.keywords) ? data.keywords.join(", ") : data.keywords || ""
          });
        } else {
          const docRef = doc(db, "Product", productId);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            const data = docSnap.data();
            setProduct({
              ...data,
              title: data.title || "",
              keywords: Array.isArray(data.keywords) ? data.keywords.join(", ") : data.keywords || ""
            });
          }
        }
      } catch (error) {
        console.error("Error fetching product:", error);
      }
    };
    fetchProduct();
  }, [location.state, productId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProduct((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const docRef = doc(db, "Product", productId);
      await updateDoc(docRef, {
        title: product.title,
        description: product.description,
        category: product.category,
        price: parseFloat(product.price),
        condition: product.condition,
        brand: product.brand,
        dimensions: product.dimensions,
        weight: product.weight,
        countryOfOrigin: product.countryOfOrigin,
        keywords:
          typeof product.keywords === "string"
            ? product.keywords.split(",").map((kw) => kw.trim())
            : Array.isArray(product.keywords)
            ? product.keywords
            : [],
      });
      navigate("/MyAccount");
    } catch (error) {
      console.error("Error updating product:", error);
    }
  };

  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete this product?")) {
      try {
        const docRef = doc(db, "Product", productId);
        await deleteDoc(docRef);
        navigate("/MyAccount");
      } catch (error) {
        console.error("Error deleting product:", error);
      }
    }
  };

  return (
    <div className="add-product-container">
      <h2 className="form-title">Edit Product</h2>
      <form onSubmit={handleSubmit} className="add-product-form">
        <div className="form-group">
          <label>Product Title:</label>
          <input
            type="text"
            name="title"
            value={product.title}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Description:</label>
          <textarea
            name="description"
            value={product.description}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Category:</label>
          <input
            type="text"
            name="category"
            value={product.category}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Price (AED):</label>
          <input
            type="number"
            name="price"
            value={product.price}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Condition:</label>
          <select
            name="condition"
            value={product.condition}
            onChange={handleChange}
            required
          >
            <option value="new">New</option>
            <option value="used">Used</option>
            <option value="refurbished">Refurbished</option>
          </select>
        </div>

        <div className="form-group">
          <label>Brand:</label>
          <input
            type="text"
            name="brand"
            value={product.brand}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Dimensions:</label>
          <input
            type="text"
            name="dimensions"
            value={product.dimensions}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Weight (kg):</label>
          <input
            type="number"
            name="weight"
            value={product.weight}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Country of Origin:</label>
          <input
            type="text"
            name="countryOfOrigin"
            value={product.countryOfOrigin}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Keywords (comma separated):</label>
          <input
            type="text"
            name="keywords"
            value={product.keywords}
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="add-product-button">
          Update Product
        </button>

        <button type="button" className="delete-product-button" onClick={handleDelete}>
          Delete Product
        </button>
      </form>
    </div>
  );
}

export default EditProduct;
